import { create } from 'zustand';

interface AppState {
  selectedDay: string | null;
  selectedSlot: string | 'All';
  selectedStopId: string | null;
  setSelectedDay: (day: string | null) => void;
  setSelectedSlot: (slot: string | 'All') => void;
  setSelectedStopId: (stopId: string | null) => void;
}

export const useAppState = create<AppState>((set) => ({
  selectedDay: null,
  selectedSlot: 'All',
  selectedStopId: null,
  setSelectedDay: (day) => set({ selectedDay: day }),
  setSelectedSlot: (slot) => set({ selectedSlot: slot }),
  setSelectedStopId: (stopId) => set({ selectedStopId: stopId }),
}));

